import React, { useEffect, useState } from "react";
import "../BookService/bookservice.scss";
import {
	IonButton,
	IonCol,
	IonIcon,
	IonImg,
	IonInput,
	IonLabel,
	IonRow,
	IonSlide,
	IonSlides,
	IonText,
	isPlatform,
} from "@ionic/react";
import { connect } from "react-redux";
import "./bodyPanel.scss";
import * as constants from "../../../constants";
import { TinderLikeCard } from "@webileapps/react-stack-cards";
import Swipeable from "react-swipy";
import { InAppBrowser } from "@ionic-native/in-app-browser";
import { AlertMessage } from "../../../utils/alertMessage";
import { hideMessenger, openIntercomMessanger } from "../../../intercom";

interface commonPointsState {
	service: any;
	showArticle: any;
	FaqList?: any;
	articlesData?: any;
}

export const CommonPointsForEachService: React.FC<commonPointsState> = ({
	service,
	showArticle,
	FaqList = [],
	articlesData = [],
}) => {
	const [state, setState] = React.useState("Front");
	const [isOpen, SetIsOpen] = React.useState(false);
	const [selectedFaqIds, setselectedFaqIds] = useState<any>([]);
	const [tinderWidth, setTinderWidth] = useState(320);
	const [showCallusPopup, setshowCallusPopup] = useState(false);
	const [cardArr, setCardArr] = useState(articlesData || []);

	React.useEffect(() => {
		// console.log("SD ========");
		setCardArr(articlesData || []);
	}, [(articlesData || []).length]);

	var Tinder: any = null;
	const remove = (index: any) => {
		Tinder.swipe();
		const a = document.getElementsByClassName("sc-bxivhb");
		a[a.length - Tinder.state.current].setAttribute("style", "display:none;");
		setCardArr([
			...cardArr.slice(0, index),
			...cardArr.slice(index, cardArr.length),
			cardArr[index],
		]);
	};
	function checkMediaQuery() {
		const mediaQuery = window.matchMedia("(max-width: 700px)");
		if (mediaQuery.matches) {
			setTinderWidth(window.innerWidth - 0.25 * window.innerWidth);
		} else {
			setTinderWidth(window.innerWidth - 0.78 * window.innerWidth);
		}
	}
	window.addEventListener("resize", checkMediaQuery);

	const handleCallUs = () => {
		if (isPlatform("desktop")) {
			setshowCallusPopup(true);
		} else {
			document.location.href = `tel:${constants.CONTACT_US_MOBILE}`;
		}
	};
	return (
		<>
			{Boolean(service.features.length) && (
				<div className="whats-included" style={{ padding: 20 }}>
					<IonLabel className="whats-included-heading" color="tertiary">
						{constants.WHATS_INCLUDED}
					</IonLabel>
					<div className="list-of-included-services">
						{service.features.map((fea: any, ind: any) => (
							<div className="sd_rowcenter" key={ind} style={{ width: "100%" }}>
								<div className="check_img sd_checkmark">
									<IonImg src="/images/whatsInclude.svg" className="sd_checkmark" />
								</div>
								<div className="whats_included_point">
									<IonLabel className="sd_feature">{fea}</IonLabel>
								</div>
							</div>
						))}
					</div>
				</div>
			)}
			{!!service.longDescription && (
				<div className="common-service-div">
					<IonLabel className="sd_wi_text" color="tertiary">
						{!!showArticle ? constants.SERVICE_DETAILS : "Workshop Details"}
					</IonLabel>
					<div className="service-description">
						<IonLabel className="sd_sd_text" color="secondary">
							{service.longDescription}
						</IonLabel>
					</div>
				</div>
			)}
			{!!service.faqListId && (
				<div className="common-service-div">
					<IonLabel className="sd_wi_text">{constants.FAQs}</IonLabel>
					{FaqList.map((qns: any, faqInd: any) => (
						<div
							className="sd_faq_parent"
							onClick={() => {
								if (!selectedFaqIds.includes(qns.faqId)) {
									setselectedFaqIds([qns.faqId]);
								} else {
									setselectedFaqIds([]);
								}
							}}
							key={faqInd}
						>
							<div className="sd_sub_parent">
								<IonLabel className="sd_faq_text">{qns.question}</IonLabel>
								<IonImg
									className={
										selectedFaqIds.includes(qns.faqId) ? "up_arrow" : "down_arrow"
									}
									src={
										selectedFaqIds.includes(qns.faqId)
											? "images/download_arrow.svg"
											: "images/download_arrow.svg"
									}
								/>
							</div>
							{selectedFaqIds.includes(qns.faqId) && (
								<div className="sd_faq_text sd_margintop_ten">
									<IonLabel className="sd_faq_text">{qns.answer}</IonLabel>
								</div>
							)}
						</div>
					))}
				</div>
			)}
			{/* 
      // !uncomment this section when we have the help data
      */}
			{/* <div className="common-service-div">
        <IonLabel className="sd_wi_text">{constants.HELP}</IonLabel>
        <div
          className="sd_chat"
          onClick={() => {
            openIntercomMessanger();
          }}
        >
          <IonLabel color="light" className="contact-us">
            {constants.CHAT_WITH_US}
          </IonLabel>
          <IonImg src="/images/chatWithUs.svg" />
        </div>
        <div
          className="sd_call"
          onClick={() => {
            handleCallUs();
            hideMessenger();
          }}
        >
          <IonLabel color="light" className="FAQ-question">
            {constants.CALL_US}
          </IonLabel>
          <IonImg src="/images/Vector.svg" />
        </div>
        {!!showArticle && !!cardArr.length && (
          <div className="sd_tncard_parent">
            {(cardArr || []).length > 1 ? (
              <TinderLikeCard
                colors={[]}
                width={100 + "%"}
                height="100"
                direction={"swipeRight"}
                duration={400}
                ref={(node) => {
                  Tinder = node;
                }}
                className="tinder"
              >
                {cardArr.map((ele: any, index: any) => (
                  <Swipeable onAfterSwipe={() => remove(index)} key={index}>
                    <div className="sd_arcard" style={{ backgroundColor: ele.displayColor }}>
                      <div className="sd_ar_div">
                        <IonLabel className="sd_ar_title">{ele.title}</IonLabel>
                      </div>
                      <p className="sd_ar_srtDes">{ele.shortDescription}</p>
                      <IonImg
                        onClick={() => {
                          const target = "_blank";
                          const options =
                            "location=no,clearcache=yes,hideurlbar=yes,hidenavigationbuttons=yes,cleardata=yes,toolbarposition=top";
                          InAppBrowser.create(ele.webpageUrl, target, options);
                        }}
                        src="/images/right_arrow_circle.svg"
                        className="sd_circle_arrow"
                      />
                    </div>
                  </Swipeable>
                ))}
              </TinderLikeCard>
            ) : (
              <div className="sd_arcard" style={{ backgroundColor: cardArr[0].displayColor }}>
                <div className="sd_ar_div">
                  <IonLabel className="sd_ar_title">{cardArr[0].title}</IonLabel>
                </div>
                <IonLabel className="sd_ar_srtDes">{cardArr[0].shortDescription}</IonLabel>
                <IonImg src="/images/right_arrow_circle.svg" className="sd_circle_arrow" />
              </div>
            )}
          </div>
        )}
      </div> */}
			<AlertMessage
				showAlert={showCallusPopup}
				alertMessage={"Please react out to us at +91 9848012345 "}
				onDidDismiss={() => {
					setshowCallusPopup(false);
				}}
				alertHeader={"Call Us"}
				hideActionBtns={true}
				actionItemForAlert={() => {
					setshowCallusPopup(false);
				}}
			/>
		</>
	);
};
export default connect(null, {})(CommonPointsForEachService);
